module.exports = __webpack_public_path__ + "img/man.590791c7.png";